import { render, staticRenderFns } from "./cooperationPlatformDialog.vue?vue&type=template&id=0f0b3cda&scoped=true"
import script from "./cooperationPlatformDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./cooperationPlatformDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./cooperationPlatformDialog.vue?vue&type=style&index=0&id=0f0b3cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0b3cda",
  null
  
)

export default component.exports